App.CarrierItemComponent = Em.Component.extend
  classNames: [ 'carrier' ]
  model: null

  inappSupport: Em.inject.service()

  actions:
    showModal: ->
      @sendAction('onApply', @get('model.name'))
      false
